import { useGetCompanyQuery } from 'app/api_v2/agency/queries';
import TickedAddDirect from 'app/main/common/tickets/ticket-details/components/ticket-add-direct/TicketAddDirect';
import { getUserRoleInfo } from 'app/ui_v2/helpers/users';
import ViewIcon from 'app/ui_v2/icons/ViewIcon';
import { Link, useParams } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

import { canViewerEdit } from '../../helpers';
import ProfileInfo from '../../profile-info/ProfileInfo';
import PublishProfile from '../../publish-profile/PublishProfile';
import AgencyStatusBadge from './AgencyStatusBadge';

export default function LayoutHeader() {
  const { id = '' } = useParams();

  const { isSuccess, data } = useGetCompanyQuery(id);

  const isEditable = canViewerEdit(data);
  const { isAdmin } = getUserRoleInfo();

  return (
    <Box pt={4} pb={2}>
      {isSuccess && data && (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap={'wrap'}>
            <Box display="flex" alignItems="flex-start">
              <Typography component="h2" variant="h1" sx={{ mb: 0 }} className="with-indicator">
                {data.name || data.companyName || 'Draft'}
              </Typography>

              <Box mt={1} mx={3}>
                <AgencyStatusBadge state={data.state} />
              </Box>
            </Box>
            {isEditable && (
              <Box mb={4}>
                <Box display="flex" gap={2} alignItems="flex-start">
                  <Box>
                    <Button
                      variant="outlined"
                      color="primary"
                      disableElevation
                      component={Link}
                      to={`/agency/public/${data.id}`}
                    >
                      <ViewIcon />
                      <Box ml={1}>Preview</Box>
                    </Button>
                  </Box>
                  <Box>{(data.state === 'draft' || !data.state) && <PublishProfile data={data} />}</Box>
                </Box>
              </Box>
            )}
            {isAdmin && data && (
              <Box mb={4} display="flex" alignItems="flex-start">
                <TickedAddDirect companyId={data.id} companyName={data.name} inspectorProfileId="" inspectorName="" />
              </Box>
            )}
          </Box>
          <ProfileInfo data={data} />
        </>
      )}
    </Box>
  );
}
